import navDashboardIcon from 'assets/nav_dashboard_icon.png';

interface Properties {
  width?: number;
  height?: number;
}

const DashboardIconActive = ({ width = 16, height = 16 }: Properties) => {
  return (
    <img
      src={navDashboardIcon}
      alt=''
      width={width}
      height={height}
      style={{ filter: 'brightness(0) invert(1)' }}
    />
  );
};

export default DashboardIconActive;
